export default __webpack_public_path__ + "static/media/Regprint.39f49ac6.png";